import ReactDOM from 'react-dom';
import {
  ChangeEvent,
  Dispatch, SetStateAction, useRef, useState
 } from "react";
import { useOutside } from 'hooks/UseOutside';

import UploadFilePentagon from '../../../../assets/img/upload-file-pentagon.png';

import {
  InputFile, ModalCloseButton, ModalContainer, ModalSection, ModalSubtitle, ModalTitle, SaveButton, SaveLabel
} from './_setDocumentModal';

interface ISetDocumentModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  setDoc: Dispatch<SetStateAction<File | undefined>>;
  callback?: () => void;
}

export const SetDocumentModal = ({
  toggleModal, setDoc, callback
}: ISetDocumentModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);

  const [docFile, setDocFile] = useState<File | undefined>();

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;

    if (files && files.length) {
      setDocFile(files[0]);
    }
  }

  const handleSaveDoc = () => {
    setDoc(docFile);

    handleCloseModal();
  }

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);

      if(callback){
        callback()
      }
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalSection className={`${hideModal ? 'modal-set-document--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ ModalCloseButton>
        <ModalTitle>
          Anexe seu documento
        </ModalTitle>
        <ModalSubtitle>
          {docFile?.name || 'São aceitos os formatos: JPEG e PDF.'}
        </ModalSubtitle>
        <img src={UploadFilePentagon} alt="File upload" />
        {docFile ? (
          <SaveButton
            type="button"
            onClick={handleSaveDoc}
          >
            Salvar alterações
          </SaveButton>
        ):(
          <SaveLabel
            htmlFor="modalSetDocumentInput"
          >
            Enviar Anexo
          </SaveLabel>
        )}
        <InputFile
          type="file"
          accept="image/jpeg, application/pdf"
          id="modalSetDocumentInput"
          onChange={handleFileChange}
        />
      </ModalContainer>
    </ModalSection>
    ,modalRoot
  )
}
